import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function DecimalValidator(control: AbstractControl): ValidationErrors | null {
  //numbers and period (any precision/scale)
  if (!control.value || control.value.toString().match(/^\d+(\.\d+)?$/)) {
    return null;
  } else {
    return { invalidFormat: true };
  }
}

//e.g. maxScale: 2
//123 -> OK
//123. -> BAD
//123.4 -> OK
//123.45 -> OK
//123.456 -> BAD
export function generateDecimalValidatorForMaxScale(maxScale: number) {
  if (maxScale < 1) {
    throw new Error('maxScale must be >= 1');
  }
  let pattern = '^\\d+(\\.\\d';
  for (let i = 1; i < maxScale; i++) {
    pattern += '\\d?';
  }
  pattern += ')?$';
  return Validators.pattern(pattern);
}
